import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const WelcomeSidebar: FC = () => {
  const { t } = useTranslation();

  return (
    <div className='welcome-sidebar'>
      <h2>{t('sidebar.welcome.h2')}</h2>
      <p>{t('sidebar.welcome.paragraph_1')}</p>
      <p>{t('sidebar.welcome.paragraph_2')}</p>
    </div>
  );
};

export default WelcomeSidebar;
